import { CATEGORIES_KEYS } from "./const";
import stepRegistry from "./stepRegistry";

import {
  CapitalGoods,
  CategoryBusinessTravel,
  CategoryDownstreamLeasedAssets,
  CategoryEmployeeCommuting,
  CategoryFranchise,
  CategoryInvestments,
  CategoryProcessingOfSoldProducts,
  CategoryUpstreamLeasedAssets,
  CategoryUseOfSoldProducts,
  DownstreamTransportationAndDistribution,
  PurchasedGoodsAndServices,
  TreatmentOfSoldProducts,
  UpstreamTransportationAndDistribution,
  WasteGeneratedInOperations
} from "./components/Category";

stepRegistry.register(CATEGORIES_KEYS.purchasedGoodsAndServices, PurchasedGoodsAndServices);
stepRegistry.register(CATEGORIES_KEYS.capitalGoods, CapitalGoods);
stepRegistry.register(CATEGORIES_KEYS.upstreamTransportationAndDistribution, UpstreamTransportationAndDistribution);
stepRegistry.register(CATEGORIES_KEYS.wasteGeneratedInOperations, WasteGeneratedInOperations);
stepRegistry.register(CATEGORIES_KEYS.businessTravel, CategoryBusinessTravel);
stepRegistry.register(CATEGORIES_KEYS.downstreamLeasedAssets, CategoryDownstreamLeasedAssets);
stepRegistry.register(CATEGORIES_KEYS.downstreamTransportationAndDistribution, DownstreamTransportationAndDistribution);
stepRegistry.register(CATEGORIES_KEYS.employeeCommuting, CategoryEmployeeCommuting);
stepRegistry.register(CATEGORIES_KEYS.franchises, CategoryFranchise);
stepRegistry.register(CATEGORIES_KEYS.investments, CategoryInvestments);
stepRegistry.register(CATEGORIES_KEYS.processingOfSoldProducts, CategoryProcessingOfSoldProducts);
stepRegistry.register(CATEGORIES_KEYS.upstreamLeasedAssets, CategoryUpstreamLeasedAssets);
stepRegistry.register(CATEGORIES_KEYS.useOfSoldProducts, CategoryUseOfSoldProducts);
stepRegistry.register(CATEGORIES_KEYS.treatmentOfSoldProducts, TreatmentOfSoldProducts);

export { default as CategoryQuestionnaire } from "./CategoryQuestionnaire";
